import { combineReducers } from 'redux';
import { reducers as makePayment } from './makePayment/reducers';
import { reducers as paymentDetails } from './paymentDetails/reducers';

export const reducers = combineReducers({
  makePayment,
  paymentDetails,
});
